import { makeRequest } from 'utils/requestLogger';

export default (commentID) =>
    makeRequest('put', `/api/comments/${commentID}/unflag-comment`);



// WEBPACK FOOTER //
// ./src/app/features/onlineRoundtables/services/comment/unflagComment.js